import { render, staticRenderFns } from "./langue.vue?vue&type=template&id=41f08dd0&scoped=true"
import script from "./langue.vue?vue&type=script&lang=js"
export * from "./langue.vue?vue&type=script&lang=js"
import style0 from "./langue.vue?vue&type=style&index=0&id=41f08dd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f08dd0",
  null
  
)

export default component.exports